import { Card } from "@/components/ui/card";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export function KpiCard({ label, value, sub, trend, icon: Icon, accent = "default", testId }) {
  const accentColor =
    accent === "danger"
      ? "text-danger"
      : accent === "success"
      ? "text-success"
      : accent === "info"
      ? "text-brand"
      : "text-foreground/70";

  const trendUp = typeof trend === "number" && trend >= 0;

  return (
    <Card
      data-testid={testId}
      className="p-5 hover:-translate-y-1 hover:border-brand/30 hover:shadow-glow-cyan transition-all duration-300 ease-out animate-fade-up relative overflow-hidden"
    >
      <div className="flex items-start justify-between">
        <p className="text-[11px] tracking-[0.14em] uppercase font-semibold text-muted-foreground">
          {label}
        </p>
        {Icon && <Icon className={`h-[18px] w-[18px] ${accentColor}`} strokeWidth={1.75} />}
      </div>
      <p className="mt-3 font-mono text-2xl md:text-[28px] font-medium tracking-tight text-foreground">
        {value}
      </p>
      <div className="mt-2 flex items-center gap-2">
        {typeof trend === "number" && (
          <span
            className={`inline-flex items-center gap-0.5 text-xs font-medium ${
              trendUp ? "text-success" : "text-danger"
            }`}
          >
            {trendUp ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownRight className="h-3.5 w-3.5" />}
            {Math.abs(trend)}%
          </span>
        )}
        {sub && <span className="text-xs text-muted-foreground">{sub}</span>}
      </div>
    </Card>
  );
}
